// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"64b32881","276":"ed92ef19","458":"b3fd0572","514":"86f9dfbf","594":"11fcbaeb","665":"a5bfa7f4","787":"8784e6cd","820":"afdc8f47","980":"998b7b46"}[chunkId] + ".chunk.js";
};